import {
  CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_BEGIN,
  CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_SUCCESS,
  CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_FAILURE,
  CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_DISMISS_ERROR,
} from './constants'

import { processDefaultAndTotals } from '../../common/formulario/processDefaultAndTotals'
import { getCatalogSchema } from './getCatalogSchema'
import mock0km from '../mockData_basic_0km'
import mockUsado from '../mockData_basic_usado'

export function loadSchemasFromCatalogo() {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_BEGIN,
    })

    const promise = new Promise((resolve, reject) => {
      // TODO: sacar schema en info basica y usar maquetacion html
      const doRequest = getCatalogSchema()
      doRequest.then(
        (res) => {
          const {
            defaults: advancedInfoDefaults,
            countTotalFields: advancedInfoTotalFields
          } = processDefaultAndTotals(res.data.data.advancedInfoSchema)

          const mockUsados = {
            ...mockUsado.data.data.basicInfoSchema,
            infoVehiculo: {
              ...mockUsado.data.data.basicInfoSchema.infoVehiculo,
              COMBU: {
                ...mockUsado.data.data.basicInfoSchema.infoVehiculo.COMBU,
                options: res.data.data.advancedInfoSchema.summary.resumen.COMBU.options,
              },
            }
          };

          const {
            defaults: basicInfoUsadoDefaults,
            countTotalFields: basicInfoUsadoTotalFields,
            required: basicInfoUsadoRequired,
          } = processDefaultAndTotals(mockUsados)
          const {
            defaults: basicInfoNuevoDefaults,
            countTotalFields: basicInfoNuevoTotalFields,
            required: basicInfoNuevoRequired,
          } = processDefaultAndTotals(mock0km.data.data.basicInfoSchema)

          dispatch({
            type: CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_SUCCESS,
            data: {
              basicInfoUsadoSchema: mockUsados,
              basicInfoNuevoSchema: mock0km.data.data.basicInfoSchema,
              advancedInfoTotalFields,
              basicInfoUsadoTotalFields,
              basicInfoNuevoTotalFields,
              advancedInfoSchema: res.data.data.advancedInfoSchema,
              requiredFieldsUsado: { ...basicInfoUsadoRequired /* ...advancedInfoRequired */ },
              requiredFieldsNuevo: { ...basicInfoNuevoRequired /* ...advancedInfoRequired */ },
              defaults: {
                ...advancedInfoDefaults,
                ...basicInfoUsadoDefaults,
                ...basicInfoNuevoDefaults,
              },
            },
          })
          resolve({ ...advancedInfoDefaults, ...basicInfoUsadoDefaults, ...basicInfoNuevoDefaults })
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoadSchemasFromCatalogoError() {
  return {
    type: CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loadSchemasFromCatalogoPending: true,
        loadSchemasFromCatalogoError: null,
      }

    case CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_SUCCESS:
      // The request is success
      return {
        ...state,
        loadSchemasFromCatalogoPending: false,
        loadSchemasFromCatalogoError: null,
        ...action.data,
      }

    case CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_FAILURE:
      // The request is failed
      return {
        ...state,
        loadSchemasFromCatalogoPending: false,
        loadSchemasFromCatalogoError: action.data.error,
        
        totalFields: 0,
        advancedInfoSchema: null,
        requiredFields: null,
      }

    case CAR_DATA_CATALOGO_LOAD_SCHEMAS_FROM_CATALOGO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loadSchemasFromCatalogoError: null,
      }

    default:
      return state
  }
}
